import { useCallback, useState } from 'react';
import ImageIcon from 'components/icons/image';
import { ActionButton } from './styled';
import AttachFilesModal from './AttachFilesModal';

interface Props {
    acceptedFormats?: string;
    disabled?: boolean;
    onAttachFiles?: (filesList: FileList | null) => void,
}

const AttachFileButton = ({
    acceptedFormats,
    disabled = false,
    onAttachFiles = () => {},
}: Props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = useCallback(() => setIsModalOpen(true), []);
    const closeModal = useCallback(() => setIsModalOpen(false), []);

    return (
        <>
            <ActionButton
                tooltip="Attach files"
                icon={<ImageIcon />}
                onClick={openModal}
                disabled={disabled}
            />
            <AttachFilesModal
                isOpen={isModalOpen}
                acceptedFormats={acceptedFormats}
                onRequestClose={closeModal}
                onAttach={onAttachFiles}
            />
        </>
    );
};

export default AttachFileButton;
